import { render } from "./AddCartWithImages.vue?vue&type=template&id=1f3386dc&scoped=true"
import script from "./AddCartWithImages.vue?vue&type=script&lang=js"
export * from "./AddCartWithImages.vue?vue&type=script&lang=js"

import "./AddCartWithImages.vue?vue&type=style&index=0&id=1f3386dc&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3386dc"]])

export default __exports__